import api from './api';

/**
 * Service for communicating with the eVitals Backend RAG AI Assistant.
 *
 * @param {string} message - User question.
 * @param {string|null} role - Optional role context from Redux auth.
 * @returns {Promise<{ answer: string, sources: Array, retrieval: object }>}
 */
export async function askRagAssistant(message, role = null) {
  if (!message || typeof message !== 'string' || message.trim() === '') {
    throw new Error('Message cannot be empty.');
  }

  const payload = {
    message: message.trim()
  };

  if (role && typeof role === 'string' && role.trim() !== '') {
    payload.role = role.trim();
  }

  try {
    const response = await api.post('/chat/rag', payload);
    
    if (response.data && response.data.success && response.data.data) {
      return response.data.data;
    }

    // Fallback if data is directly on response
    if (response.data && response.data.answer) {
      return response.data;
    }

    throw new Error(response.data?.message || 'Invalid response from AI Assistant.');
  } catch (error) {
    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Unable to reach eVitals AI Assistant. Please check your connection and try again.';

    throw new Error(errorMsg);
  }
}

export default {
  askRagAssistant
};
